module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": "",
      "mt-7": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg7": "",
      "sm12": ""
    }
  }, [_c('h1', {
    staticClass: "fw-bold"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.lostAccessApp")))]), _vm._v(" "), _c('p', {
    staticClass: "font-lg mt-3"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("lostGoogleAuthentication.lostSecretkey")) + "\n                        ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLostHintMessage),
      expression: "isShowLostHintMessage"
    }],
    staticClass: "col-height-auto ml-2 font-lg",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg10": "",
      "sm12": ""
    }
  }, [_c('p', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.submitRequestMessageBefore"))), _c('a', {
    on: {
      "click": _vm.goUserRequest
    }
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.customerService")))]), _vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.submitRequestMessageAfter")))])]), _vm._v(" "), _c('p', {
    staticClass: "font-lg mt-3"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("lostGoogleAuthentication.haveSecretkey")) + "\n                        ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSendEmailForm),
      expression: "isShowSendEmailForm"
    }],
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md10": "",
      "lg10": "",
      "sm12": "",
      "ml-2": ""
    }
  }, [_c('p', {
    staticClass: "font-1x"
  }, [_vm._v(_vm._s(_vm.$t("lostGoogleAuthentication.accepteEmail")))]), _vm._v(" "), _c('v-form', {
    ref: "sendEmailForm",
    model: {
      value: (_vm.sendEmailValid),
      callback: function($$v) {
        _vm.sendEmailValid = $$v
      },
      expression: "sendEmailValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": _vm.$t('lostGoogleAuthentication.email'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.sendEmailForm.regEmail),
      callback: function($$v) {
        _vm.$set(_vm.sendEmailForm, "regEmail", $$v)
      },
      expression: "sendEmailForm.regEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.secretRules,
      "counter": 16,
      "label": _vm.$t('lostGoogleAuthentication.secretKey'),
      "clearable": "",
      "required": ""
    },
    model: {
      value: (_vm.sendEmailForm.authenticationSecret),
      callback: function($$v) {
        _vm.$set(_vm.sendEmailForm, "authenticationSecret", $$v)
      },
      expression: "sendEmailForm.authenticationSecret"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "primary--text",
    attrs: {
      "outline": "",
      "disabled": !_vm.sendEmailValid
    },
    on: {
      "click": _vm.sendEmail
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("common.submit")) + "\n                                ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53848030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/faq/LostGoogleAuthentication.vue
// module id = 439
// module chunks = 0